import { useHistory } from 'react-router-dom'
import {
  ButtonAgain, ButtonBack, ButtonsContainer, Container, Info,
} from './TaxCouponFinishPage.styles'

export default () => {
  const history = useHistory()

  const handleAgainClick = () => history.push('/tax-coupon/entry/secret')
  const handleBackClick = () => history.push('/')

  return (
    <Container>
      <h1>Entrada de cupom fiscal</h1>

      <Info>
        <h2>Entrada Finalizada</h2>
        <p>Para realizar uma nova entrada ou voltar para tela inicial selecione uma das opções</p>
        <ButtonsContainer>
          <ButtonAgain type='button' onClick={handleAgainClick}>Nova Entrada</ButtonAgain>
          <ButtonBack type='button' onClick={handleBackClick}>Voltar</ButtonBack>
        </ButtonsContainer>
      </Info>
    </Container>
  )
}
